import { Modal, Table, Radio, Col, Row } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { SearchType } from "../../../Interfaces/SearchInterfaces";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { mainActions } from "../../../../store/main/mainSlice";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { UseMutateAsyncFunction } from "react-query";
import { AxiosResponse } from "axios";

type PropsType = {
  customers: any;
  loading: boolean;
  tableKey: number;
  setIsCustomersListOpen: any;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  search: string;
  setCustomers: Dispatch<SetStateAction<any>>;
  getCutomersMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
    },
    unknown
  >;
};
export const CustomersListModal = ({
  customers,
  loading,
  tableKey,
  setIsCustomersListOpen,
  page,
  setPage,
  search,
  setCustomers,
  getCutomersMutation,
}: PropsType) => {
  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);

  const [t] = useTranslation("common");

  const customer = useSelector((state: any) => state.main.customer);

  const dispatch = useDispatch();
  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      getCutomersMutation({ limit: page * 5 + 5, q: search }).then((res) => {
        if (page > maxPage) setMaxPage(page);

        setCustomers(res.data.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const columns: ColumnsType<SearchType> = [
    {
      title: `${t("name")}`,
      dataIndex: "name",
      key: "name",
      width: "15rem",
      className: "table-header main",
    },
    {
      title: `${t("phone-number")}`,
      dataIndex: "phone",
      key: "phone",
      width: "10rem",
      className: "table-row main",
      render: (phone) => {
        if (phone) {
          const phoneNumberParts = phone.split("/");
          const phoneNumber =
            phoneNumberParts.length > 1 ? phoneNumberParts[1] : phone;
          return <span>{phoneNumber}</span>;
        }
        return null;
      },
    },
    {
      title: `${t("address")}`,
      key: "address",
      width: "15rem",
      className: "table-row main",
      render: (text, record: any) => (
        <span>
          {record?.country?.name} , {record?.city} , {record?.addressLine1}
        </span>
      ),
    },
    {
      title: `${t("notes")}`,
      key: "notes",
      className: "table-row main",
      render: (text, record: any) => <span>{record.notes}</span>,
    },
    {
      title: `${t("select")}`,
      key: "action",
      align: "center",
      className: "table-row main",
      width: "5rem",
      render: (_, record) => {
        return (
          <Radio checked={customer?.id === record.id}>
            {customer?.id === record.id}
          </Radio>
        );
      },
    },
  ];
  const confirm = (record: any) => {
    Modal.confirm({
      title: (
        <>
          <Row style={{ justifyContent: 'space-around' }}>
            <Col span={3}>
              <ExclamationCircleFilled
                style={{
                  marginTop: "22px",
                  fontSize: "45px",
                  color: "#FFBC39",
                }}
              />
            </Col>

            <Col span={19}>
              <Col
                style={{
                  fontSize: "32px",
                  color: "#212121",
                }}
              >
                {" "}
                {t("confirm-selecting")}
              </Col>
              <Col
                span={24}
                style={{
                  fontSize: "16px",
                  color: "#212121",
                  wordWrap: "break-word",
                }}
              >
                {t("please-confirm-selecting-customer")}
              </Col>
            </Col>
          </Row>
        </>
      ),

      icon: null,
      centered: true,
      onOk: () => {
        dispatch(mainActions.setCustomer(record));
        setIsCustomersListOpen(false);
        document.body.classList.remove("body-scroll-lock");
      },
      okText: `${t("confirm")}`,
      cancelText: `${t("cancel")}`,
      okButtonProps: {
        style: {
          height: "40px",
          background: "#1677FF",
          color: "#fff",
          width: "100px",
        },
      },
      cancelButtonProps: {
        style: {
          color: "#1677FF",
          border: "1px solid #1677FF",
          height: "40px",
          width: "100px",
        },
      },
    });
  };
  return (
    <>
      <Table
        key={tableKey}
        columns={columns}
        className="bill"
        dataSource={customers}
        loading={loading}
        style={{ width: "100%" }}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        pagination={{ pageSize: 5 }}
        rowKey={(record) => record.id}
        onChange={(selectedPage) => {
          setPrevPage(page);
          setPage(selectedPage?.current ?? 1);
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              confirm(record);
            },
          };
        }}
      />
    </>
  );
};
